import React, { useState } from "react";
import { Formik, Form, Field, ErrorMessage } from "formik";
import * as Yup from "yup";
import ConfirmationDialog from "../header/confirmation.dialog";
import HeaderComponent from "../header/header";
import { submitChangePassword } from "../../services/dashboard.service";
import withRouter from "../../common/with-router";
import { logout } from "../../services/auth.service";
import { FaEye, FaEyeSlash, FaLock } from "react-icons/fa";
import { SnackbarUI, useSnackbar } from "../header/snackbarProvider";
import { Helmet } from "react-helmet-async";

const ChangePasswordComponent = ({ router }) => {
  const { navigate, location } = router;


  const [showNewPassword, setShowNewPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const { showSnackbar, snackbar } = useSnackbar();
  const [openConfirmationDialog, setOpenConfirmationDialog] = useState(false);
  const [dialogValues, setDialogValues] = useState({});
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [initialValues, setInitialValues] = useState({
    newPasswordData: "",
    newPasswordConfirmData: "",
  });

  const handleDialogClose = () => {
    setOpenConfirmationDialog(false);
    setIsSubmitting(false); // Re-enable submit button
  };

  const toggleNewPasswordVisibility = () => {
    setShowNewPassword((prevState) => !prevState);
  };

  const toggleConfirmPasswordVisibility = () => {
    setShowConfirmPassword((prevState) => !prevState);
  };

  const validationSchema = Yup.object().shape({
    newPasswordData: Yup.string()
      .min(3, "Password must be at least 3 characters")
      .max(40, "Password must not exceed 40 characters")
      .required("Please enter new password"),
    newPasswordConfirmData: Yup.string()
      .oneOf([Yup.ref("newPasswordData"), null], "Passwords must match")
      .required("Please enter confirm password"),
  });



  const handleChangePasswordSubmit = async (values, { setSubmitting, validateForm }) => {
    const errors = await validateForm();
    if (Object.keys(errors).length > 0) {
      setSubmitting(false);
      return;
    }

    setIsSubmitting(true);
    setOpenConfirmationDialog(true);
    setDialogValues(values);
  };

  const handleDialogConfirm = async () => {
    setOpenConfirmationDialog(false);
    if (isSubmitting) {
      setIsLoading(true);
      try {
        let result = await submitChangePassword(dialogValues.newPasswordConfirmData);
        const message = result;
        if (message.includes("Change Password Successful")) {
          setInitialValues({
            newPasswordData: "",
            newPasswordConfirmData: "",
          });


        logout("L");
        navigate("/login", {
          state: {
            snackbarMessage: message,
            snackbarSeverity: "success",
          },
        });


        } else if (message.includes("The new Password is the same as the old password!")) {
          showSnackbar(message, "danger");
        } else {
          showSnackbar(message, "danger");
        }
      } catch (error) {
        let resMessage =
          error.response?.data?.message ||
          (error.response?.status === 401
            ? "OTP generation failed. Unauthorized request."
            : "Unexpected error occurred");
            showSnackbar(resMessage, "danger");
      } finally {
        setIsLoading(false);
      }
    }
  };
  
  
  return (
    <>
               <Helmet>
                     <title>CHANGE PASSWORD SMARTFORUM - Society for Microwaves, Antennas and Radar Technologies</title>
                      <meta name="description" content="Join SMART, a technology-driven community shaping the future of innovation, research, and collaboration." />
                      <meta name="robots" content="index, follow" />
                  </Helmet>
      <HeaderComponent />
      <div className="smart-main-content">
        <section id="fixed-sub-nav" className="fade-in vh-100">
          <section id="changePassword" className="py-4 header">
            <div className="row d-flex justify-content-center align-items-center">
              <div className="col-lg-6 col-md-8 col-12 mt-2 pt-1">
                <div className="card text-black shadow-lg form-card-login">
                  <div className="card-body p-md-5">
                    <p className="text-center h2 fw-bold mb-2 pb-4 form-name">
                      Change Password?
                    </p>

                           {/* Render the Snackbar UI here at the top of the page */}
                          {snackbar.open && <SnackbarUI message={snackbar.message} type={snackbar.type} />}
                              
                    <Formik
                      initialValues={initialValues}
                      validationSchema={validationSchema}
                      onSubmit={handleChangePasswordSubmit}
                    >
                      {({ touched, errors }) => (
                        <Form>
                          {/* New Password Field */}
                          <div className="mb-4">
                            <div className="form-floating position-relative">
                              <Field
                                type={showNewPassword ? "text" : "password"}
                                id="newPasswordData"
                                name="newPasswordData"
                                className={`form-control ${
                                  touched.newPasswordData && errors.newPasswordData
                                    ? "is-invalid"
                                    : ""
                                }`}
                                placeholder="New Password"
                              />
                              <label htmlFor="newPasswordData">
                                <FaLock className="me-2"/>New Password
                                <span className="required-input">*</span>
                              </label>
                              <span className="password-toggle-icon" onClick={toggleNewPasswordVisibility}>
                                     {showNewPassword? <FaEyeSlash/>:<FaEye/> }
                              
                              </span>
                              <ErrorMessage name="newPasswordData" component="div" className="invalid-feedback" />
                            </div>
                          </div>

                          {/* Confirm Password Field */}
                          <div className="mb-4">
                            <div className="form-floating position-relative">
                              <Field
                                type={showConfirmPassword ? "text" : "password"}
                                id="newPasswordConfirmData"
                                name="newPasswordConfirmData"
                                className={`form-control ${
                                  touched.newPasswordConfirmData && errors.newPasswordConfirmData
                                    ? "is-invalid"
                                    : ""
                                }`}
                                placeholder="Confirm Password"
                              />
                              <label htmlFor="newPasswordConfirmData">
                              <FaLock className="me-2"/>Confirm Password
                                <span className="required-input">*</span>
                              </label>
                              <span className="password-toggle-icon" onClick={toggleConfirmPasswordVisibility}>
                               {showConfirmPassword? <FaEyeSlash/>:<FaEye/> }
                              </span>
                              <ErrorMessage name="newPasswordConfirmData" component="div" className="invalid-feedback" />
                            </div>
                          </div>

                          {/* Submit Button */}
                          <div className="d-flex justify-content-center mt-5">
                            <button type="submit" className="btn btn-lg w-100 login-button">
                              Change Password
                            </button>
                          </div>

                          <ConfirmationDialog
                            open={openConfirmationDialog}
                            onClose={handleDialogClose}
                            onConfirm={handleDialogConfirm}
                            title=""
                            message="Confirm password change?"
                          />
                        </Form>
                      )}
                    </Formik>
                  </div>
                </div>
              </div>
            </div>
          </section>
        </section>
      </div>
    </>
  );
};

export default withRouter(ChangePasswordComponent);
